import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { formatDate, parseDate } from '@jd/jmtd-tools/es/date';
import { fixZero } from '../tools/date';
export default {
  datePicker: {
    pleaseSelect: '请选择日期',
    pleaseSelectTime: '请选择时间',
    day: ['日', '一', '二', '三', '四', '五', '六'],
    pickerHeaderFormat: 'YYYY年MM月',
    picker: {
      day: {
        label: '按天',
        echo: function echo(value) {
          return formatDate(parseDate(value), 'YYYY-MM-DD');
        }
      },
      week: {
        label: '按周',
        echo: function echo(value) {
          return "".concat(value[0], "\u5E74").concat(value[1], "\u5468");
        }
      },
      month: {
        label: '按月',
        pickerHeaderFormat: 'YYYY年',
        echo: function echo(value) {
          return "".concat(value[0], "-").concat(fixZero(value[1]));
        },
        panelLabel: '月'
      },
      range: {
        label: '自定义',
        echo: function echo(_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              start = _ref2[0],
              end = _ref2[1];

          return "".concat(start, " ~ ").concat(end);
        },
        rangeEcho: function rangeEcho(day) {
          return "".concat(day, "\u5929");
        }
      }
    },
    date: '日期',
    startTime: '开始时间',
    endTime: '结束时间',
    startDate: '开始日期',
    endDate: '结束日期',
    selectTime: '选择时间',
    selectDate: '选择日期'
  },
  common: {
    all: '全部',
    reset: '重置',
    confirm: '确定',
    clear: '清空',
    cancel: '取消',
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    noData: '暂无数据',
    selected: '已选',
    clearAll: '清空全部',
    selectAll: '全选'
  },
  pagination: {
    sizeOptionLabel: function sizeOptionLabel(length) {
      return "".concat(length, "\u6761/\u9875");
    },
    goto: '前往',
    gotoPage: '页'
  },
  table: {
    times: '倍',
    fair: '持平',
    noData: '无数据'
  }
};